export class FileDetailsData {
    statusRequest: FormData;
    batchId: any;
    fileName: string;
    fileError: boolean;
    filePath: string;
}